import { render, staticRenderFns } from "./ShopDevice.vue?vue&type=template&id=683a2525&scoped=true"
import script from "./ShopDevice.vue?vue&type=script&lang=js"
export * from "./ShopDevice.vue?vue&type=script&lang=js"
import style0 from "./ShopDevice.vue?vue&type=style&index=0&id=683a2525&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.12_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_65uhlok3ryww266g2rjqqwj3cm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683a2525",
  null
  
)

export default component.exports